// src/pages/CGV.js
import React from "react";
import "../index.css";

export default function CGV() {
  const sections = [
    {
      title: "Prestataire",
      body: (
        <>
          <p>
            <strong>Maxime HUYLEBROECK EI</strong>
            <br />
            Siège : 23 allée René Peters, 54510 Tomblaine
            <br />
            SIRET : 799 493 952 00037 — TVA : FR19799493952
            <br />
            Email : <a href="mailto:contact@maximeh.fr">contact@maximeh.fr</a> — Tel :{" "}
            <a href="tel:+33663252202">+33 6 63 25 22 02</a>
          </p>
          <p className="legal-note">Ci-après « le Prestataire ».</p>
        </>
      ),
    },

    {
      title: "1 — Objet et champ d’application",
      body: (
        <p>
          Les présentes conditions définissent les modalités des prestations de photographie culinaire, portraits,
          reportages, prise de vues de lieux, ainsi que des prestations vidéo éventuellement proposées par le Prestataire.
          Elles s’appliquent à toute commande professionnelle (restaurants, hôtels, traiteurs, artisans, entreprises,
          agences).
        </p>
      ),
    },

    {
      title: "2 — Devis, commande & confirmation",
      body: (
        <p>
          Chaque mission fait l’objet d’un devis mentionnant la nature de la prestation, le lieu, la date, les modalités
          de réalisation, les livrables prévus, les droits accordés et le montant total. La commande est validée par la
          signature du devis, par un accord écrit ou par le paiement d’un acompte. Le devis signé vaut bon de commande.
        </p>
      ),
    },

    {
      title: "3 — Tarifs & conditions de règlement",
      body: (
        <>
          <p>
            Les tarifs sont exprimés en euros hors taxes, auxquels s’ajoute la TVA applicable. Pour les prestations
            réalisées auprès de clients établis en Belgique ou au Luxembourg disposant d’un numéro de TVA valide, la
            facturation est établie hors taxe, conformément aux règles intracommunautaires : la TVA est due par le
            preneur (autoliquidation).
          </p>
          <p>
            Sauf indication contraire, un acompte de 30 % est demandé à la validation du devis. Le solde est exigible à
            réception de la facture. La livraison des photographies n’intervient qu’après règlement intégral du solde ;
            aucune image ne sera remise avant encaissement complet.
          </p>
          <p>
            En cas de retard de paiement, des pénalités de retard au taux légal et une indemnité forfaitaire de 40 €
            seront appliquées conformément à l’article L441-10 du Code de commerce. L’utilisation des images et
            l’ensemble des droits associés sont suspendus tant que les sommes dues ne sont pas réglées.
          </p>
        </>
      ),
    },

    {
      title: "4 — Réalisation de la prestation",
      body: (
        <p>
          Le Prestataire s’engage à délivrer un travail conforme aux standards professionnels de la photographie
          gastronomique : maîtrise de la lumière, rendu naturel, fidélité aux dressages, cohérence visuelle et respect de
          l’univers du Client. Le Client garantit que les lieux, les plats et les équipes sont préparés et disponibles aux
          horaires convenus. Tout retard ou désorganisation peut modifier la durée de la prestation ou son tarif.
        </p>
      ),
    },

    {
      title: "5 — Livraison des fichiers",
      body: (
        <>
          <p>
            Les photographies sont livrées uniquement après réception du paiement intégral de la facture finale. Elles
            sont fournies en JPEG haute définition pour l’impression ainsi qu’en JPEG optimisé pour une utilisation web
            et réseaux sociaux. Les fichiers bruts (RAW/RAF) ne sont pas fournis.
          </p>
          <p>
            Les fichiers définitifs (JPEG) sont archivés pendant une durée de six (6) mois à compter de leur livraison.
            Au-delà de ce délai, leur conservation n’est plus garantie.
          </p>
        </>
      ),
    },

    {
      title: "6 — Propriété intellectuelle et licences d’utilisation",
      body: (
        <>
          <h3>6.1. Droits d’auteur</h3>
          <p>
            Le Prestataire reste titulaire de l’intégralité des droits d’auteur sur ses photographies conformément au Code
            de la propriété intellectuelle. Le Client bénéficie d’une licence d’utilisation dont l’étendue est définie au
            devis.
          </p>

          <h3>6.2. Licence Standard (incluse)</h3>
          <p>
            Elle permet l’usage des images pour la communication de l’établissement : site internet, réseaux sociaux,
            menus, supports internes, newsletters, dossiers ou documents en lien direct avec l’activité. La licence est
            limitée au périmètre défini dans le devis.
          </p>

          <h3>6.3. Licence Étendue (sur option)</h3>
          <p>
            Elle couvre les utilisations plus larges : campagnes publicitaires, affichage, presse, édition, packaging,
            diffusion multi-pays ou tout usage dépassant la communication directe de l’établissement. Elle fait l’objet
            d’un devis complémentaire.
          </p>

          <h3>6.4. Mention du crédit</h3>
          <p>
            Sauf clause de confidentialité, toute publication doit indiquer la mention : © Maxime H — www.maximeh.fr
          </p>
        </>
      ),
    },

    {
      title: "7 — Droit à l’image",
      body: (
        <p>
          Le Client garantit que toutes les autorisations nécessaires ont été obtenues pour photographier les personnes,
          lieux, œuvres, produits ou éléments soumis à un droit particulier. Le Prestataire ne pourra être tenu responsable
          en cas de défaut d’autorisation.
        </p>
      ),
    },

    {
      title: "8 — Confidentialité",
      body: (
        <>
          <p>
            Le Prestataire traite comme confidentielles toutes les informations auxquelles il accède : recettes non
            publiques, dressages, espaces privés, projets en cours ou éléments sensibles liés à l’établissement.
          </p>
          <p>Une clause de confidentialité renforcée peut être ajoutée sur simple demande.</p>
        </>
      ),
    },

    {
      title: "9 — Annulation et report",
      body: (
        <>
          <p>
            Une annulation à plus de (5) cinq jours entraîne la conservation de l’acompte. Une annulation à moins de (5)
            cinq jours entraîne la facturation de 50 % de la prestation. Une annulation à moins de (48) quarante-huit
            heures entraîne la facturation du montant total.
          </p>
          <p>
            En cas d’empêchement du Prestataire, une nouvelle date est proposée ou l’acompte est remboursé intégralement.
          </p>
        </>
      ),
    },

    {
      title: "10 — Responsabilités",
      body: (
        <>
          <p>
            Le Prestataire est responsable de la bonne exécution de la prestation telle que définie dans le devis. Il ne
            peut être tenu responsable d’un rendu non conforme lorsque les conditions de prise de vue sont dégradées ou
            différentes de celles prévues. Sa responsabilité ne peut être engagée au-delà du montant total de la
            prestation.
          </p>
        </>
      ),
    },

    {
      title: "11 — Prestations vidéo (le cas échéant)",
      body: (
        <>
          <p>
            Lorsque la mission comprend de la vidéo, les règles précédentes s’appliquent également à la captation, au
            montage, aux musiques utilisées, aux formats livrés et aux droits d’utilisation.
          </p>
          <p>
            Toute diffusion publique doit être couverte par les licences adaptées. Lorsque la prestation inclut une
            production vidéo, les musiques utilisées sont soit libres de droits, soit sous licence. Toute demande
            spécifique de musique non libre de droits entraîne un coût supplémentaire lié à l’acquisition d’une licence.
            Le Prestataire n’est pas responsable de l’usage fait par le Client de musiques ajoutées par lui-même.
          </p>
        </>
      ),
    },

    {
      title: "12 — Références et portfolio",
      body: (
        <p>
          Sauf demande contraire expresse, le Prestataire peut utiliser certaines images pour son portfolio, ses supports
          professionnels ou ses réseaux sociaux. Aucune image sensible ou non publique n’est diffusée sans accord.
        </p>
      ),
    },

    {
      title: "13 — Données personnelles",
      body: (
        <>
          <p>
            Les données du Client sont utilisées exclusivement pour le suivi administratif et ne sont communiquées à aucun
            tiers.
          </p>
          <p>Un droit d’accès, de modification et de suppression est disponible sur simple demande.</p>
        </>
      ),
    },

    {
      title: "14 — Force majeure",
      body: (
        <p>
          Aucune des parties ne peut être tenue responsable en cas d’événement imprévisible et irrésistible rendant
          impossible la réalisation de la prestation.
        </p>
      ),
    },

    {
      title: "15 — Litiges",
      body: (
        <p>
          Les présentes conditions sont régies par le droit français. Une solution amiable est recherchée en priorité. À
          défaut, les tribunaux compétents sont ceux du lieu du siège du Prestataire.
        </p>
      ),
    },

    {
      title: "16 — Conditions de travail, sécurité et hygiène",
      body: (
        <>
          <p>
            Le Client garantit que les conditions de travail permettent la réalisation de la prestation en toute sécurité :
            espace suffisant, sol dégagé, absence d’obstacles dangereux, matériel en état de fonctionnement.
          </p>
          <p>
            Dans un environnement de cuisine, le Client s’engage à prévenir le Prestataire de toute zone à risque (sols
            mouillés, températures élevées, zones de circulation). Le Prestataire peut interrompre la prestation s’il
            estime que la sécurité n’est pas assurée.
          </p>
        </>
      ),
    },

    {
      title: "17 — Respect des plats, dressages et denrées",
      body: (
        <p>
          Le Prestataire manipule uniquement les plats ou éléments alimentaires avec l’accord du Chef ou des équipes. Le
          Client reste responsable de l’état final du plat présenté à la prise de vue. Toute demande de modification
          esthétique, substitution ou effet visuel devra être validée par le Client ou le Chef.
        </p>
      ),
    },

    {
      title: "18 — Conservation et réutilisation des scènes",
      body: (
        <p>
          Les plats, dressages, produits et mises en scène réalisés pour la séance ne sont pas conservés par le
          Prestataire et sont remis au Client à l’issue de la prestation. Le Prestataire ne peut être tenu responsable de
          la dégradation des préparations après la prise de vue. Toute consommation éventuelle de ces préparations par le
          Prestataire ne peut intervenir qu’avec l’accord oral et explicite du Client.
        </p>
      ),
    },

    {
      title: "19 — Prises de vue supplémentaires ou modifications",
      body: (
        <p>
          Toute prise de vue non prévue dans le devis initial (plats supplémentaires, photos d’équipe, portraits
          additionnels, plans d’ambiance) fera l’objet d’une facturation complémentaire ou d’un ajustement horaire. Toute
          demande de modification d’images livrées (retouches, changements de couleur, détourage, modifications avancées)
          est également facturée selon le tarif en vigueur.
        </p>
      ),
    },

    {
      title: "20 — Conditions météorologiques (si shooting extérieur)",
      body: (
        <p>
          En cas de conditions météorologiques défavorables rendant impossible la réalisation de la prestation extérieure,
          une nouvelle date est proposée. Aucun dédommagement n’est dû si la météo empêche la réalisation à la date
          prévue.
        </p>
      ),
    },

    {
      title: "21 — Matériel et panne",
      body: (
        <p>
          Le Prestataire utilise un matériel professionnel entretenu. En cas de panne imprévisible ou de problème
          technique majeur empêchant la réalisation totale ou partielle de la prestation, la responsabilité du Prestataire
          se limite au remboursement des sommes versées.
        </p>
      ),
    },

    {
      title: "22 — Sous-traitance (styliste culinaire, assistant, vidéaste)",
      body: (
        <p>
          Le Prestataire peut faire appel à un prestataire externe (styliste culinaire, assistant lumière, vidéaste,
          maquilleur, etc.) avec l’accord du Client. Les conditions et tarifs du sous-traitant peuvent faire l’objet d’un
          devis complémentaire.
        </p>
      ),
    },

    {
      title: "23 — Livraison",
      body: (
        <p>
          Le délai de livraison standard est généralement de 3 à 5 jours ouvrés, sauf mention contraire sur le devis.
          Toute demande de livraison express (moins de 48 h) fait l’objet d’un supplément précisé au devis ou facturé au
          tarif d’urgence en vigueur.
        </p>
      ),
    },

    {
      title: "24 — Hébergement et déplacements (prestations longues)",
      body: (
        <>
          <p>
            Les déplacements sont inclus jusqu’à <strong>120 km aller/retour</strong> depuis le siège du Prestataire
            (Tomblaine – 54510). Au-delà de ce périmètre, les frais de déplacement font l’objet d’une facturation
            forfaitaire, précisée sur la grille tarifaire en vigueur ou au devis.
          </p>
          <p>
            Les frais annexes éventuels (hébergement, restauration, stationnement, péages) peuvent être facturés au Client
            lorsqu’ils sont nécessaires à la réalisation de la prestation, selon les modalités précisées au devis.
          </p>
        </>
      ),
    },

    {
      title: "25 — Épreuves test / moodboard / préparation",
      body: (
        <p>
          Une phase de préparation (moodboard, repérage, définition de style, choix de lumière) peut être incluse ou
          facturée selon l’étendue demandée. Toute demande de préparation supplémentaire fait l’objet d’un devis.
        </p>
      ),
    },

    {
      title: "26 — Non-concurrence / discrétion",
      body: (
        <p>
          Le Prestataire respecte la confidentialité des recettes, dressages et créations non dévoilées au public. Le
          Client peut demander une clause de confidentialité renforcée si les images concernent un lancement produit, une
          carte inédite ou un événement sous embargo.
        </p>
      ),
    },

    {
      title: "27 — Préparation culinaire",
      body: (
        <p>
          Le Client garantit que les plats, produits, dressages, ingrédients et éléments à photographier sont présentés
          dans un état conforme aux attentes esthétiques et sanitaires requises. En cas de défaut de présentation (plats
          abîmés, desséchés, oxydés, refroidis, brûlés…), le Prestataire ne peut être tenu responsable du rendu final des
          images. Toute nouvelle préparation d’un plat est à la charge du Client.
        </p>
      ),
    },

    {
      title: "28 — Stylisme culinaire (si styliste non inclus)",
      body: (
        <p>
          Sauf indication contraire sur le devis, le stylisme culinaire (préparation esthétique des plats, choix des
          accessoires, mise en scène culinaire) n’est pas inclus dans la prestation. Si nécessaire, une option styliste
          culinaire peut être ajoutée et fera l’objet d’un devis séparé.
        </p>
      ),
    },

    {
      title: "29 — Clause matériel et espace minimum requis",
      body: (
        <p>
          Le Client s’engage à fournir un espace de prise de vue suffisamment grand, propre, dégagé et disposant d’un
          accès électrique fonctionnel pour permettre l’installation du matériel du Prestataire. En cas de conditions
          inadaptées empêchant l’installation du matériel, le Prestataire peut interrompre la prestation sans
          remboursement de l’acompte.
        </p>
      ),
    },

    {
      title: "30 — Imprévision",
      body: (
        <p>
          Toute modification substantielle du lieu de prise de vue, des horaires, des conditions d’accès ou du déroulement
          prévu impactant l’organisation initiale pourra donner lieu à une adaptation du devis. Le Prestataire informera
          le Client au plus tôt des éventuels ajustements nécessaires.
        </p>
      ),
    },

    {
      title: "31 — Retouches avancées",
      body: (
        <p>
          Les retouches standard incluent corrections colorimétriques, contraste, densité et recadrage léger. Toute
          demande de retouche avancée (suppression d’éléments, reconstruction, photomontage, nettoyage numérique complexe,
          changements de textures ou couleurs) fait l’objet d’une facturation spécifique selon le tarif en vigueur.
        </p>
      ),
    },

    {
      title: "32 — Droits additionnels pour usage tiers",
      body: (
        <p>
          La licence accordée au Client ne couvre que sa propre communication. Toute utilisation par un tiers (groupe
          hôtelier, franchise, fournisseur, agence, chef invité, média, réseau de restaurants, marque partenaire…) fait
          l’objet d’une licence supplémentaire à obtenir auprès du Prestataire.
        </p>
      ),
    },

    {
      title: "33 — Responsabilité du client pour matériel prêté",
      body: (
        <p>
          En cas de dégradation du matériel par un membre de l’équipe du Client, par un incident de cuisine ou par
          mauvaise manipulation, le Client pourra être tenu responsable des réparations ou du remplacement en cas de faute
          ou négligence avérée.
        </p>
      ),
    },

    {
      title: "34 — Défaillance du client (mise en scène incomplète)",
      body: (
        <p>
          Le Prestataire n’est pas responsable d’une baisse du nombre d’images livrées lorsque le Client n’a pas fourni
          les plats, produits ou espaces à photographier au moment convenu. Aucun remboursement n’est possible dans ce cas.
        </p>
      ),
    },

    {
      title: "35 — Clause sécurité alimentaire (photographie culinaire)",
      body: (
        <p>
          Le Prestataire ne manipule pas les denrées alimentaires au-delà des nécessités de stylisme basique. Le Client
          demeure responsable des conditions d’hygiène, chaîne du froid, températures, normes HACCP et sécurité sanitaire
          des aliments photographiés.
        </p>
      ),
    },

    {
      title: "36 — Clause de transfert de fichiers (sécurisation)",
      body: (
        <p>
          Le Prestataire s’engage à transmettre les fichiers via une plateforme sécurisée. Toute perte de fichiers après
          téléchargement par le Client n’engage plus la responsabilité du Prestataire. Un renvoi peut être effectué tant
          que les archives sont conservées.
        </p>
      ),
    },

    {
      title: "37 — Clause d’archivage prolongé (option)",
      body: (
        <p>
          Une option d’archivage longue durée (supérieure à 6 mois) peut être proposée au Client sur demande. Les tarifs
          sont disponibles sur simple demande.
        </p>
      ),
    },

    {
      title: "38 — Prestations au forfait",
body: (
  <>
    <p>Les prestations ponctuelles sont proposées sous forme de forfaits horaires ou journaliers.</p>
    <p>
      Toute prolongation ou dépassement de la durée initialement prévue peut entraîner l’application du forfait
      supérieur, conformément aux conditions précisées au devis ou à la grille tarifaire en vigueur.
    </p>
    <p>
      Les forfaits correspondent exclusivement à la durée de la prestation photographique.
      Les frais de déplacement éventuels sont précisés distinctement au devis.
    </p>
  </>
),
    },

    {
      title: "39 — Carnets de prestations",
      body: (
        <>
          <p>
            Les carnets correspondent à un nombre défini de prestations, valables pour une durée limitée, selon les
            modalités précisées dans la grille tarifaire et le devis.
          </p>
          <p>Les carnets sont non remboursables, non fractionnables et non cumulables.</p>
          <p>
            Toute prestation non utilisée à l’issue de la période de validité est considérée comme perdue.
          </p>
          <p>
            Les frais de déplacement peuvent être inclus dans les carnets, selon la formule choisie et le périmètre géographique défini au devis.
          </p>
        </>
      ),
    },

    {
      title: "40 — Abonnements",
      body: (
        <>
          <p>
            Les abonnements impliquent un engagement ferme pour une durée définie (12 ou 24 mois), précisée au devis.
          </p>
          <p>
            Les prestations incluses sont réalisées selon une périodicité mensuelle, non cumulables d’un mois sur l’autre.
          </p>
          <p>
            Toute séance non réalisée sur un mois donné est considérée comme perdue et ne peut être reportée.
          </p>
          <p>
            Les abonnements sont facturés mensuellement, sauf mention contraire au devis.
          </p>
          <p>
            Les frais de déplacement peuvent être inclus dans le cadre des abonnements, selon la formule choisie et le périmètre géographique défini au devis.
          </p>
          <p className="legal-note">
            Les conditions particulières figurant sur le devis et la grille tarifaire en vigueur complètent et
            prévalent, le cas échéant, sur les présentes Conditions Générales de Vente.
          </p>
        </>
      ),
    },
  ];

  return (
    <main className="legal-page">
      <header className="legal-hero">
        <h1>Conditions Générales de Vente (CGV)</h1>
        <p>Maxime HUYLEBROECK — Entrepreneur Individuel (EI)</p>
      </header>

      <div className="legal-stack">
        {sections.map((s) => (
          <section className="legal-card" key={s.title}>
            <h2>{s.title}</h2>
            {s.body}
          </section>
        ))}
      </div>
    </main>
  );
}